<template>
  <nuttrema-layout-page-content class="is-forgot">

    <nuttrema-empty-result
      v-if="_get(AuthenticationForgotPassword, 'saved')"
      icon="fal fa-paper-plane">
      <template slot="text">
        <h1>{{ $t('label.email_send') }}</h1>
        <h4 v-html="_markdown.render($t('label.we_have_sent_an_email_containing_the_special_link'))"></h4>
        <p v-html="_markdown.render($t('label.didnt_receive_an_email'))"></p>
      </template>
    </nuttrema-empty-result>

    <form-forgot-password
       v-else
       theme="global"
       class="is-no-section-border is-no-center-scroll is-center-vertical"
      :AuthenticationForgotPassword="AuthenticationForgotPassword"
      @submit="onFormSubmit">
    </form-forgot-password>

  </nuttrema-layout-page-content>
</template>

<script>
import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';

import PageForgotPassword from 'components/pages/shared/forgot-password/page-forgot-password';

export default {
  name: 'page-professional-forgot-password',
  mixins: [
    PageForgotPassword,
  ],
  components: {
    NuttremaLayoutPageContent,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/public/forgot-password/page-professional-forgot-password.vue